<template>
  <div>
    <div class="row center-block">
        <div class="col-md-12">
        <div class="box box-info">
            <form @submit.prevent class="form-horizontal">
            <div class="box-body">
                <div class="form-group col-md-5">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                        <input type="text" :disabled="true" class="form-control" placeholder="SO Number" v-model="formData.name">
                    </h1>                   
                </div>
                <div class="form-group col-md-7">
                <h3 style="margin-top:0px;">
                    <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
                </div>
                <div class="row">
                <div class="col-md-12">
                    <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a href="#tab_2" data-toggle="tab" aria-expanded="true">Order Items</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_BILLING_PLAN }"><a href="#tab_3" data-toggle="tab" aria-expanded="true">Billing Plan</a></li>
                    </ul>
                    </div>
                    <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                        <div class="box no-border form-horizontal">
                        <div class="row">
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="comboCustomer" class="col-sm-4 control-label">Customer</label>
                                <div class="col-sm-8">
                                <input type="text" :disabled="true" class="form-control" v-model="formData.customerName">
                                <!-- <select2 :id="'comboCustomer'" :options="listCustomer" :value="customerSelected" :enable="false" @change="onChangeCustomer($event)">
                                </select2>                           -->
                                </div>                     
                            </div>                                         
                            </div>
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="inputDocumentDate" class="col-sm-4 control-label">Document Date</label>
                                <div class="col-sm-8">
                                <input type="text" :disabled="true" class="form-control" v-model="formData.documentDate">
                                <!-- <div class="input-group">
                                    <datepicker style="width:100%" v-if="showDocumentDate" :readonly="true" name="documentDate" :value=formData.documentDate
                                                :format=DATE_FORMAT :input-attr="{ 'id': 'documentDate', 'disabled': viewMode == MODE_VIEW ? true : false }"
                                                :input-style="{ 'width': '100%' }"></datepicker>
                                </div>                          -->
                                </div> 
                            </div>                      
                            </div>
                        </div>                           
                        <div class="row">
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="comboBillTo" class="col-sm-4 control-label">Bill To</label>
                                <div class="col-sm-8">
                                <input type="text" :disabled="true" class="form-control" v-model="formData.billToName">
                                <!-- <select2 :id="'comboBillTo'" :options="listBillTo" :value="billToSelected" :enable="false">
                                </select2>                           -->
                                </div>                   
                            </div>                                         
                            </div>
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="comboProject" class="col-sm-4 control-label">Project</label>
                                <div class="col-sm-8">
                                <input type="text" :disabled="true" class="form-control" v-model="formData.projectName">
                                <!-- <select2 :id="'comboProject'" :options="listProject" :value="projectSelected" :enable="false">
                                </select2>                           -->
                                </div>
                            </div>                      
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="comboCurrency" class="col-sm-4 control-label">Currency</label>
                                <div class="col-sm-8">
                                <input type="text" :disabled="true" class="form-control" v-model="formData.currencyName">
                                <!-- <select2 :id="'comboCurrency'" :options="listCurrency" :value="currencySelected" :enable="false">
                                </select2>                           -->
                                </div>                   
                            </div>                                         
                            </div>
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="inputTotalAmount" class="col-sm-4 control-label">Total Amount</label>
                                <div class="col-sm-8">
                                    <input type="text" :disabled="true" class="form-control" v-model="formData.totalAmount">
                                </div>  
                            </div>                      
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                            <div class="form-group">
                                <label for="inputReference" class="col-sm-4 control-label">Reference</label>
                                <div class="col-sm-8">
                                <input type="text" :disabled="true" class="form-control" v-model="formData.reference">
                                </div>                   
                            </div>                                         
                            </div>
                            <div class="col-md-6">
                            <div class="form-group">

                            </div>                      
                            </div>
                        </div>                            
                        </div>
                    </div>                        
                    <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_2">
                        <div class="col-md-12">
                        <div class="box no-border">
                            <!-- <div class="box-header" style="height:40px;">          
                            <div class="box-tools">              
                                <button @click="onCreateOrderItem" class="btn btn-primary">Create</button>
                            </div>
                            </div>                               -->
                            <div class="box-body no-padding table-responsive">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <!-- <th style="width:80px;text-align:center;">Action</th> -->
                                    <th style="text-align:left;">Product</th>
                                    <th style="text-align:left;">Description</th>
                                    <th style="text-align:right;">Quantity</th>
                                    <th style="text-align:right;">Unit Price</th>
                                    <th style="text-align:right;">Discount</th>
                                    <th style="text-align:right;">Tax</th>
                                    <th style="text-align:right;">Tax Amt</th>
                                    <th style="text-align:right;">Amount</th>
                                    <th style="text-align:center;">Currency</th>
                                    <th style="text-align:left;">Reference</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, i) in listSOItem" v-bind:key="i">
                                    <td style="width:10px;text-align:right">{{ startSequenceSOItem + i + 1}}</td>
                                    <!-- <td style="width:80px;text-align:center">
                                    <a href="#" v-on:click="onDisplaySOItem(row)" ref="displayRowSOItem" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                    </a>
                                    <a href="#" v-on:click="onEditSOItem(row)" ref="editRowSOItem" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                    </a>
                                    <a href="#" v-on:click="onDeleteSOItem(row)" ref="deleteRowSOItem" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                    </a>                                        
                                    </td> -->
                                    <td style="text-align:left;">{{ row.productName }}</td>
                                    <td style="text-align:left;">{{ row.productDescription }}</td>
                                    <td style="text-align:right;">{{ row.quantity }}</td>
                                    <td style="text-align:right;">{{ row.price }}</td>
                                    <td style="text-align:right;">{{ row.discount }}</td>
                                    <td style="text-align:right;">{{ row.tax }}</td>
                                    <td style="text-align:right;">{{ row.taxAmount }}</td>
                                    <td style="text-align:right;">{{ row.amount }}</td>
                                    <td style="text-align:center;">{{ row.currencyName }}</td>
                                    <td style="text-align:left;">{{ row.reference }}</td>
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.productId }}</td>
                                    <td hidden>{{ row.salesOrderId }}</td>
                                    <td hidden>{{ row.currencyId }}</td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_BILLING_PLAN }" class="tab-pane" id="tab_3">
                        <div class="col-md-12">
                        <div class="box no-border">
                            <!-- <div class="box-header" style="height:40px;">          
                            <div class="box-tools">              
                                <button @click="onCreateOrderItem" class="btn btn-primary">Create</button>
                            </div>
                            </div>                               -->
                            <div class="box-body no-padding table-responsive">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <!-- <th style="width:80px;text-align:center;">Action</th> -->
                                    <th style="text-align:right;">Seq. No</th>
                                    <th style="text-align:right;">Amount</th>
                                    <th style="text-align:center;">Currency</th>
                                    <th style="text-align:left;">Invoice</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, i) in listSOBillingPlan" v-bind:key="i">
                                    <td style="width:10px;text-align:right">{{ startSequenceBillPlan + i + 1}}</td>
                                    <!-- <td style="width:80px;text-align:center">
                                    <a href="#" v-on:click="onDisplaySOItem(row)" ref="displayRowSOItem" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                    </a>
                                    <a href="#" v-on:click="onEditSOItem(row)" ref="editRowSOItem" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                    </a>
                                    <a href="#" v-on:click="onDeleteSOItem(row)" ref="deleteRowSOItem" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                    </a>                                        
                                    </td> -->
                                    <td style="text-align:right;">{{ row.sequenceNo }}</td>
                                    <td style="text-align:right;">{{ row.amount }}</td>
                                    <td style="text-align:center;">{{ formData.currencyName }}</td>
                                    <td style="text-align:left;"><a href="#" @click="onShowInvoice(row.invoiceId)">{{ row.invoiceName }}</a></td>
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.invoiceId }}</td>
                                    <td hidden>{{ row.salesOrderId }}</td>
                                    <td hidden>{{ row.currencyId }}</td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </div>                        
                    </div>
                </div>                    
                </div>                 
                <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                <input type="hidden" class="form-control" id="inputCustomerId" v-model="formData.customerId">
                <input type="hidden" class="form-control" id="inputBillId" v-model="formData.billId">
                <input type="hidden" class="form-control" id="inputProjectId" v-model="formData.projectId">
                <input type="hidden" class="form-control" id="inputCurrencyId" v-model="formData.currencyId">
            </div>

            <div class="box-footer">
                <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <!-- <button @click="onCancel()" class="btn btn-warning">Cancel</button> -->
                <!-- <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button> -->
                </div>
            </div>

            </form>
        </div>          
        </div>
    </div>
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import select2 from '../../components/widgets/Select2'

const MODE_NONE = 'none'
// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_ITEMS = 'tabItems'
const TAB_BILLING_PLAN = 'tabBillingPlan'

export default {
  name: 'SalesOrderForm',
  components: {
    datepicker, select2
  },
  data() {
    return {
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_ITEMS: TAB_ITEMS,
      TAB_BILLING_PLAN: TAB_BILLING_PLAN,
      item: null,
      listData: null,
      listDataTemp: null,
      listCurrency: null,
      listProject: null,
      listCustomer: null,
      listBillTo: null,
      listSOItem: null,
      listSOItemTemp: null,
      listSOBillingPlan: null,
      listSOBillingPlanTemp: null,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        documentDate: '',
        customerId: 0,
        customerName: '',
        projectId: 0,
        projectName: '',
        billId: 0,
        billName: '',
        totalAmount: 0,
        currencyId: 0,
        currencyName: '',
        status: '',
        reference: '',
        items: [],
        billingPlan: []
      },
      customerSelected: [],
      billToSelected: [],
      projectSelected: [],
      currencySelected: [],
      showDocumentDate: false,
      tabActive: '',
      startSequenceSOItem: 0,
      startSequenceBillPlan: 0
    }
  },
  created() {
    if (this.$route.params) {
      this.callback = this.$route.params.callback
      this.formData.id = this.$route.params.id
      this.formData.customerName = this.$route.params.customerName
      this.formData.projectName = this.$route.params.projectName
      this.formData.billName = this.$route.params.billName
      this.formData.currencyName = this.$route.params.currencyName
      this.viewMode = this.$route.params.mode
    }

    this.tabActive = TAB_GENERAL
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    getDetail() {
      if (this.formData.id && this.formData.id !== 0) {
        api
          .request('Sales', 'get', '/api/SalesOrder/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data

            this.formData.id = data.entity.id
            this.formData.name = data.entity.name
            this.formData.documentDate = data.entity.documentDate
            this.formData.customerId = data.entity.customerId
            this.formData.projectId = data.entity.projectId
            this.formData.billId = data.entity.billId
            this.formData.totalAmount = data.entity.totalAmount
            this.formData.currencyId = data.entity.currencyId
            this.formData.status = data.entity.status
            this.formData.reference = data.entity.reference

            this.listSOItemTemp = data.entity.items
            this.listSOBillingPlan = data.entity.billingPlan
          })
          .then(response => {
            var arrProduct = []
            this.listSOItemTemp.forEach(soItem => {
              // Populate product
              arrProduct.push(soItem.productId)
              var arrProductUnique = arrProduct.filter(function(item, index) {
                return arrProduct.indexOf(item) >= index
              })
              arrProduct = arrProductUnique
            })

            // Get product master
            let whereClause = 'id in (' + arrProduct.join(',') + ')'
            api
              .request('Sales', 'get', '/api/Product/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProduct.length +
                                            '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
              .then(response => {
                var data = response.data
                this.listProduct = data.entity
                this.combineInquirySOItem()
              })
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    combineInquirySOItem() {
      this.listSOItemTemp.forEach(item => {
        let productName = ''
        let productDescription = ''
        this.listProduct.some(function(itemProduct, index) {
          if (item.productId === itemProduct.id) {
            productName = itemProduct.name
            productDescription = itemProduct.description
          }
        })
        item.productName = productName
        item.productDescription = productDescription
        item.currencyName = this.formData.currencyName
      })
      this.listSOItem = this.listSOItemTemp
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
    },
    onEdit() {
      this.viewMode = MODE_UPDATE
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      let name = this.callback[this.callback.length - 1].name
      let id = this.callback[this.callback.length - 1].id
      let mode = this.callback[this.callback.length - 1].mode
      this.callback.splice(this.callback.length - 1, 1)
      let params = {
        id: id,
        mode: mode,
        callback: this.callback
      }
      this.$router.push({ name: name, params: params })
    },
    onShowInvoice(invoiceId) {
      this.callback.push({
        id: this.formData.id,
        mode: this.viewMode,
        name: this.$route.name
      })
      let params = {
        id: invoiceId,
        mode: MODE_VIEW,
        callback: this.callback
      }
      this.$router.push({ name: 'Invoice Form', params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// SalesOrderForm.vue?741e5708